define(function() {
	const builder = require('civicsUtils/buildUrlParameters');
	const IPSModelCollection = require('civicsBase/ipsModelCollection');
	const CN = require('civicsUtils/constants');
	const ViewManager = require('civicsUtils/view_manager');

	return IPSModelCollection.extend({
		urlRoot: '/delegate/civics-api/api/core/views/publicinstruments',
		urlRoot2: '/delegate/civics-api/api/portal/public/instruments',
		url: function() {
			var parameters = '';
			if (this.instrumentNumber != undefined) {
				parameters += '?instrumentNumber=' + this.encodeComponent(this.instrumentNumber);

				if (this.productFamily != undefined) {
					parameters += '&productFamily=' + this.encodeComponent(this.productFamily);
				}

				if (this.includeFees && ViewManager.versionRange('8.8.0.2310')) {
					parameters += '&includefeessummary=true';
				}
			}

			let baseUrl = ViewManager.versionRange('8.8.0.2310') ? this.urlRoot2 : this.urlRoot;

			return baseUrl + parameters;
		},
		modelId:function(attrs){
			return attrs.instrumentType+'_'+attrs.id;
		},
		parse: function(response) {
			var data = response.data;
			for (i = 0; i < data.length; i++) {
				switch (data[i].instrumentType.toLowerCase()) {
					case 'buildingapplication':
						data[i]._cdrType = 'building';
						break;
					case 'businesslicense':
						data[i]._cdrType = 'businesslicense';
						break;
					case 'case':
						data[i]._cdrType = 'codeenforcement';
						break;
					case 'planningapplication':
						data[i]._cdrType = 'planning';
						break;
					case 'projectapplication':
						data[i]._cdrType = 'project';
						break;
					case 'tradelicense':
						data[i]._cdrType = 'tradelicense';
						break;
					case 'useapplication':
						data[i]._cdrType = 'use';
						break;
					default:
						console.log('undefined/invalid product family from the instrument response');
				}
				data[i].computedDescription = Handlebars.helpers['global:computedDescription'](data[i].portalDescription, data[i].description);
				if (data[i].computedDescription.trim().length <= 0) {
					data[i].computedDescription = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
				}
				data[i].locationLine1 = data[i].locationLine1 ? data[i].locationLine1 : '';
				data[i].locationLine2 = data[i].locationLine2 ? data[i].locationLine2 : '';
				data[i].displayLocation = data[i].displayLocation ? data[i].displayLocation : [];

				//there will be scenarios where instrumentName is not present, this is
				//when the turn-off the permission in ips. Add it for the sorting purposes.
				if (!data[i].instrumentName){
					data[i].instrumentName = '';
				}
			}

			if (data && data.length > 0 && this.sortByInstrumentName) {
				//sort it by instrument title then portalDescription. Max record = 7.
				data.sort((a, b) => (a.instrumentName.localeCompare(b.instrumentName) || a.portalDescription.localeCompare(b.portalDescription)));
			}

			return data;
		},
	});
});
